import { Type, type Static } from '@sinclair/typebox';
import { minimalUserSchemaObj } from '../../shared/user/user.schema';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { RelationRequest, relationRequestSchema } from '../relation-request/relation-request.schema';
import { userPresenceBaseSchema } from './user-presence.schema';
import { userProfileBaseSchema } from './user-profile.schema';
import { userRelationSchema } from './user-relation.schema';

export const GetUserRelationsResponseSchema = ListResponseSchema(userRelationSchema);

export const UpdateUserProfileResponseSchema = Type.Object({
  object: Type.Literal('UserProfileUpdated'),
});

export const VisitProfileResponseSchema = Type.Object({ object: Type.Literal('ProfileVisited') });

export const ListUserFollowersResponseSchema = ListResponseSchema(minimalUserSchemaObj);

export const ListUserFollowingResponseSchema = ListResponseSchema(minimalUserSchemaObj);

export const FollowUserResponseSchema = Type.Union([
  Type.Object({ object: Type.Literal('UserFollowed') }),
  relationRequestSchema,
]);

export const UnfollowUserResponseSchema = Type.Object({ object: Type.Literal('UserUnfollowed') });

export const BlockUserResponseSchema = Type.Object({ object: Type.Literal('UserBlocked') });

export const UnblockUserResponseSchema = Type.Object({ object: Type.Literal('UserUnblocked') });

export const GetUserProfileResponseSchema = userProfileBaseSchema;

export const GetUserPresenceResponseSchema = userPresenceBaseSchema;

export const DeleteRelationResponseSchema = Type.Null();

export type GetUserRelationsResponse = Static<typeof GetUserRelationsResponseSchema>;
export type UpdateUserProfileResponse = Static<typeof UpdateUserProfileResponseSchema>;
export type VisitProfileResponse = Static<typeof VisitProfileResponseSchema>;
export type ListUserFollowersResponse = Static<typeof ListUserFollowersResponseSchema>;
export type ListUserFollowingResponse = Static<typeof ListUserFollowingResponseSchema>;
export type FollowUserResponse<UserSpecifics = unknown> = { object: 'UserFollowed' } | RelationRequest<UserSpecifics>;
export type UnfollowUserResponse = Static<typeof UnfollowUserResponseSchema>;
export type BlockUserResponse = Static<typeof BlockUserResponseSchema>;
export type UnblockUserResponse = Static<typeof UnblockUserResponseSchema>;
export type GetUserProfileResponse = Static<typeof GetUserProfileResponseSchema>;
export type GetUserPresenceResponse = Static<typeof GetUserPresenceResponseSchema>;
export type DeleteRelationResponse = Static<typeof DeleteRelationResponseSchema>;
